'use strict';

$(document).ready(function () {
    var $sliderWrapper = $('.edge-arrow-carousel');
    var $slider = $sliderWrapper.find('.carousel-inner');

    $slider.each(function () {
        var $this = $(this);
        var settings = {
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: $this.siblings('.arrows').find('.prev'),
            nextArrow: $this.siblings('.arrows').find('.next'),
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1.39,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        };

        $this.slick(settings);
        $sliderWrapper.removeClass('d-none');
    });
});
